
import React from 'react'
import PropTypes from 'prop-types'
import { PsInfo, PsImage, PsButton } from './PersonalizationStudioReaderComponents'

function PersonalizationStudioReader({
  arrangedRecommendations = [],
  options,
  name = '',
  cssProps = {},
}) {
  return (
    <div data-testid={`ps-block-${name}`}>
      {arrangedRecommendations && arrangedRecommendations.length
        ? arrangedRecommendations.map((recommendation, index) => {
            const { imageType, infoType, buttonType } = recommendation.content || {}
            let component = null

            if (imageType) {
              component = <PsImage recommendation={recommendation} />
            } else if (infoType) {
              component = <PsInfo recommendation={recommendation} cssProps={cssProps} />
            } else if (buttonType) {
              component = <PsButton recommendation={recommendation} options={options} />
            }

            return component && <React.Fragment key={index}>{component}</React.Fragment>
          })
        : null}
    </div>
  )
}

PersonalizationStudioReader.propTypes = {
  arrangedRecommendations: PropTypes.array,
  options: PropTypes.object,
  name: PropTypes.string,
  cssProps: PropTypes.object,
}

export default PersonalizationStudioReader
